import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MapService } from '@app/shared/services/map.service';
import { StationsService } from '@app/shared/services/stations.service';
import { AlertService } from '@app/shared/services/alert.service';
import { PhotoService } from '@app/shared/services/photo.service';

@Component({
  selector: 'app-station-informations',
  templateUrl: './station-informations.component.html',
  styleUrls: ['./station-informations.component.scss']
})
export class StationInformationsComponent implements OnInit {

  public id: string = '0';
  public station: any = {};
  public vehicles: any = {};
  public loading: boolean = true;
  public marker: any = {};
  public loadingPhoto: boolean = false;
  public loadingVehicles: boolean = false;

  constructor(
    private titleService: TitleService,
    private menu: MenuService,
    private route: ActivatedRoute,
    private mapService: MapService,
    private stationService: StationsService,
    private alertService: AlertService,
    private photoService: PhotoService,
    private router: Router
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.titleService.setTitle(`Information sur la station / VOP`);
    this.menu.setMenuState('ressource', 'station', 'information');
    this.menu.id = this.id;
    this.loadInformations();
  }

  deleteStation(): void {
    this.stationService.deleteStation(this.id).then(() => {
      sessionStorage.removeItem('StationList');
      sessionStorage.removeItem('StationListMaxPages');
      sessionStorage.removeItem('StationListCurrentPage');
      sessionStorage.removeItem('StationListTimeout');
      this.router.navigate(['/ressource/station/list']);
    })
  }

  loadVehicles(): void {
    this.loadingVehicles = true;
    this.stationService.getStationVehicles(parseInt(this.id, 10)).then((res) => {
      this.vehicles = res;
    });
  }

  loadInformations(): void {
    this.loading = true;
    this.loadVehicles();
    this.stationService.getStation(this.id).then((res) => {
      this.station = res;
      setTimeout(() => {
        this.mapService.initMap('map', [this.station.latitude, this.station.longitude], 12);
        this.marker = this.mapService.addMarker([this.station.latitude, this.station.longitude]);
      });
      this.loading = false;
    });
  }

  modifyPhoto() {
    this.photoService.askFile().then((photo) => {
      this.photoService
        .modifyStationPhoto(parseInt(this.id, 10), photo)
        .then((res) => {
          if (!res || res.success === false) return this.alertService.alert("Une erreur est survenue lors du changement de la photo.");

          this.loadingPhoto = true;
          this.stationService.getStation(this.id).then((res) => {
            this.station.photo = res.photo;
            this.loadingPhoto = false;
            sessionStorage.removeItem('StationList')
          });
        });
    });
  }

  changePosition(): void {
    this.loading = true;
    this.stationService.getStation(this.id).then((res) => {
      this.station = res;
      this.mapService.removeMarker(this.marker._leaflet_id);
      this.marker = this.mapService.addMarker([this.station.latitude, this.station.longitude]);
      this.loading = false;
    });
  }

  updateStation(): void {
    this.stationService.updateStation(this.station).then(() => {
      this.alertService.alert("Les modifications ont été effectuées.");
      sessionStorage.removeItem('StationList')
    });
  }

  addVehicle(selectedVehicle): void {
    const previous = [...this.vehicles];
    this.vehicles.push(selectedVehicle);
    this.stationService.updateStationVehicles(parseInt(this.id, 10), this.vehicles.map(v => v.id))
      .then((res) => {
        if (res && res.success === false) {
          this.vehicles = previous;
          this.alertService.alert(res.message || 'Ce véhicule est déjà assigné à une autre station.');
        }
      })
      .catch(() => {
        this.vehicles = previous;
        this.alertService.alert('Erreur lors de l\'assignation du véhicule.');
      });
  }

  deleteVehicle(selectedVehicle): void {
    let index = this.vehicles.findIndex((vehicle) => vehicle.id === selectedVehicle.id);

    if (index === -1) { return; }
    this.vehicles.splice(index, 1);
    this.updateVehicles();
  }

  updateVehicles(): void {
    let idVehicleList = [];

    this.vehicles.forEach((vehicle) => {
      idVehicleList.push(vehicle.id);
    });
    this.stationService.updateStationVehicles(parseInt(this.id, 10), idVehicleList);
  }

}
